import ResourceTyped from 'Resources/ResourceTyped';

export type ExternalIntegrationEntitySyncStatus = {
	id: number;
	workflowExecutionLink: string;
	syncMessage: string | null;
	entityType: string;
	entityId: string;
	syncStatus: string;
	regDate: string;
	modDate: string;
	modBy: number;
	regBy: number;
	initiatorUserId: number | null;
	integrationId: number;
};

class ExternalIntegrationEntitySyncStatusResource extends ResourceTyped<ExternalIntegrationEntitySyncStatus> {
	constructor() {
		super('externalIntegrationEntitySyncStatus');
	}
}

const resource = new ExternalIntegrationEntitySyncStatusResource();

export default resource;
